<template>
  <div>
    <section class="section page-title cta-hire bg-gary ibcgp-page-hero">
      <div class="container">
        <div class="row">
          <div class="col-sm-10 col-lg-8 m-auto text-center text-md-left">
            <h1 class="h2 font-weight-bold mb-3">
              Entre em contato conosco
            </h1>

            <p class="mb-0 lead text-muted">
              Dúvidas sobre serviços, afiliação de município ou demonstração das soluções.
              Utilize os canais abaixo ou envie sua mensagem pelo formulário.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="address" style="margin-top: 1%; margin-bottom: 1%">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 align-self-center">
            <div class="block">
              <div class="address-block text-center">
                <div class="icon">
                  <i class="ti-mobile text-primary"></i>
                </div>

                <div class="details">
                  <h3>
                    <a href="tel:556730424800">
                      +55 (67) 3042-4800
                    </a>
                  </h3>
                </div>
              </div>

              <div class="address-block text-center">
                <div class="icon">
                  <i class="ti-email text-primary"></i>
                </div>

                <div class="details">
                  <h3>
                    <a href="mailto:contato@ibcgp.org.br">
                      contato@ibcgp.org.br
                    </a>
                  </h3>
                </div>
              </div>

              <div class="address-block text-center">
                <div class="icon">
                  <i class="ti-map-alt text-primary"></i>
                </div>

                <div class="details">
                  <a target="_blank" href="https://maps.app.goo.gl/Fr45pWDw7xV5ypmF9">
                    <h3>R. Santana, 143 - Jardim Tv Morena</h3>
                    <h3>Campo Grande - MS - 79051-200</h3>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-7 mt-5 mt-lg-0">
            <div class="google-map">
              
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3737.6258533071264!2d-54.60116122400369!3d-20.480554781035302!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9486e9509f896d27%3A0xf9b5082432f3d06e!2sIBCGP!5e0!3m2!1spt-BR!2sbr!4v1705756350398!5m2!1spt-BR!2sbr"
                    width="100%" 
                    height="400" 
                    frameborder="0" 
                    style="border:0;" 
                    allowfullscreen="" 
                    aria-hidden="false" 
                    tabindex="0"></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="contact-form section cta-hire bg-gary">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="mb-5 text-center">Deixe aqui sua mensagem</h2>
            <h3 class="mb-5 text-center">Vamos lhe dar um retorno rapidinho.</h3>
          </div>

          <div class="col-lg-12" align="center">
            <div class="alert alert-warning col-md-10" role="alert" v-if="alertError">
              Ocorreu um erro ao salvar sua mensagem. Reporte a situação pelo endereço <b>contato@ibcgp.org.br</b>.
            </div>

            <div class="alert alert-warning col-md-10" role="alert" v-if="alertEmptyFields">
              É obrigatório <b>preencher todos os campos</b> para que possamos entrar em contato!
            </div>

            <div class="alert alert-success col-md-10" role="alert" v-if="alertSuccess">
              Salvamos sua mensagem! <b>Em breve te responderemos através do e-mail informado</b>.
            </div>
          </div>

          <div class="col-12">
            
              <div class="row">
                <div class="col-md-6 mb-2">
                  <input class="form-control main ibcgp-form-control" 
                         type="text" 
                         placeholder="Como você se chama?" 
                         v-model="name">
                </div>

                <div class="col-md-6 mb-2">
                  <input class="form-control main ibcgp-form-control" 
                         type="email" 
                         placeholder="Informe aqui seu endereço de e-mail principal"
                         v-model="email">
                </div>

                <div class="col-md-12 mb-2">
                  <input class="form-control main ibcgp-form-control" 
                         type="text" 
                         placeholder="Qual seria o assunto da mensagem?"
                         v-model="subject">
                </div>

                <div class="col-md-12 mb-2">
                  <textarea class="form-control main ibcgp-form-control" 
                            name="message" 
                            rows="10" 
                            placeholder="Informe aqui os detalhes do assunto"
                            v-model="message"></textarea>
                </div>

                <div class="col-12 text-right">
                  <button class="btn btn-main-sm" @click="saveMessage">Enviar mensagem</button>
                </div>
              </div>
            
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
  export default {
    data(){
        return{
            alertError: false,
            alertEmptyFields: false,
            alertSuccess: false,
            name: '',
            email: '',
            subject: '',
            message: ''
        }
    },

    mounted () {
      const q = this.$route && this.$route.query ? this.$route.query : {}
      if (q.assunto === 'afiliacao') {
        this.subject = 'Afiliação de município ao IBCGP'
        if (!this.message) {
          this.message = 'Olá,\n\nGostaria de informações sobre a afiliação gratuita do município ao IBCGP e sobre as soluções digitais disponíveis.\n\nMunicípio: \nContato: \n'
        }
      } else if (q.assunto === 'demonstracao') {
        this.subject = 'Demonstração das soluções IBCGP'
        if (!this.message) {
          this.message = 'Olá,\n\nGostaria de alinhar uma demonstração das soluções para a equipe do município.\n\nMunicípio: \nMelhor período para contato: \n'
        }
      }
    },

    methods: {
      saveMessage: function(){
        if( this.name == '' || this.email == '' || this.subject == '' || this.message == '' ){
          this.alertEmptyFields = true;
          setTimeout(()=>{ this.alertEmptyFields = false; }, 5000);
        }else{
          let promise = this.$http.post(
            'https://api.ibcgp.org.br/formulario-contato', 
            {formularioOrigem: 'página contato - site ibcgp.org.br',
               nome: this.name,
               email: this.email,
               assunto: this.subject,
               mensagem: this.message}
          );

          promise.then(response => {
              if( response.body ){
                this.alertSuccess = true;

                setTimeout(()=>{ 
                  location.reload();
                }, 2000);
              }else{
                this.alertError = true;
              }
            }, response => {
              this.alertError = true;
              console.log(response);
            }
          );
        }
      }
    }
  }
</script>

<style scoped>
  .icon{
    margin-bottom: 0 !important;
  }
</style>